import { Button, Modal } from "components"

type ExportLayoutModalProps = {
  isOpen: boolean
  onClose: () => void
  printBlocked: boolean
  onChooseOrientation: (orientation: "portrait" | "landscape") => void
}

export function ExportLayoutModal({
  isOpen,
  onClose,
  printBlocked,
  onChooseOrientation
}: ExportLayoutModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      closeModal={onClose}
      title="OUTPUT LAYOUT OPTION"
      size="md"
      style={{ maxWidth: "460px" }}
      isdarktitle
      zIndexClassName="relative z-[100]">
      <Modal.Body className="!h-auto">
        <p className="text-sm text-base-content/80">
          Choose report layout before generating output.
        </p>
        {printBlocked ? (
          <div className="mt-4 border border-error/40 bg-error/10 p-3 text-sm text-error">
            The print window was blocked by the browser. Please allow pop-ups for
            this page and try again.
          </div>
        ) : null}
        <div className="mt-5 grid grid-cols-2 gap-3">
          <Button
            type="button"
            color="primary"
            className="font-extrabold"
            onClick={() => onChooseOrientation("portrait")}>
            Portrait
          </Button>
          <Button
            type="button"
            color="outline-secondary"
            className="font-extrabold"
            onClick={() => onChooseOrientation("landscape")}>
            Landscape
          </Button>
        </div>
      </Modal.Body>
      <Modal.Footer className="flex justify-end">
        <Button type="button" color="ghost" className="btn-sm" onClick={onClose}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
